<template>
    <v-list two-line subheader>
        <v-subheader>Agendas Creadas</v-subheader>
        <v-divider></v-divider>
        <v-flex xs12 pa-3 text-xs-center>
            <h1 v-if="!items || items.length === 0" class="caption font-weight-light">No se han encontrado agendas.</h1>
            <small v-if="!isOwnerOrAdmin" class="grey--text" >Esta es una cuenta empresa, por lo que solo los administradores pueden crear agendas.</small>
        </v-flex>
        <v-list-tile
                v-for="item in items"
                :key="item.id"
                @click="onClick(item)"
                :class="item.active ? 'white' : 'grey lighten-4'"
        >
            <v-list-tile-avatar>
                <v-avatar color="grey lighten-2">
                    <v-img v-if="item.specialist && item.specialist.avatar" :src="item.specialist.avatar"/>
                    <v-icon
                            color="secondary"
                            v-else
                    >{{item.specialist ? 'fas fa-user-nurse' : 'fas fa-medkit'}}
                    </v-icon>
                </v-avatar>
            </v-list-tile-avatar>

            <v-list-tile-content>
                <v-list-tile-title>
                    {{`${item.specialist.first_name} ${item.specialist.last_name}`}} {{item.name ? ` - ${item.name}` : ''}} <small>({{ item.service_item.description }})</small>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                    <span class="caption">
                        {{`Mod. por ${item.updated_by.first_name} ${item.updated_by.last_name[0]}. ${$moment(item.updated_at).fromNow()}`}}
                    </span>
                </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
                <v-btn class="hidden-sm-and-down mt-3 px-2" @click.stop="onActivate(item)" :color="item.active ? 'secondary' : 'primary'" small round outline depressed>
                    {{item.active ? 'Desactivar' : 'Activar'}}
                </v-btn>
                <v-btn fab class="hidden-md-and-up mt-2" @click.stop="onActivate(item)" :color="item.active ? 'secondary' : 'primary'" small round outline depressed>
                    <v-icon>{{item.active ? 'fas fa-toggle-on' : 'fas fa-toggle-off'}}</v-icon>
                </v-btn>
            </v-list-tile-action>
            <v-list-tile-action>
                <v-btn v-if="allowModifying" fab @click.stop="onDelete(item)" color="accent" small round outline depressed>
                    <v-icon size="14">fa-trash</v-icon>
                </v-btn>
            </v-list-tile-action>
        </v-list-tile>

        <kimsa-confirm
                :close-on-confirm="false"
                :loading="loadingDelete"
                ref="deleteScheduleDialog"
                title="Eliminar Agenda"
                content="Las citas asociadas a esta agenda no serán eliminadas, por lo que deberán ser canceladas manualmente. ¿Deseas continuar?"
                v-on:confirm="onDeleteConfirm"
        />

        <kimsa-confirm
                :close-on-confirm="false"
                :loading="loadingActivate"
                ref="activateScheduleDialog"
                :title="confirmTitle"
                :content="confirmContent"
                v-on:confirm="onActivateConfirm"
        />

    </v-list>
</template>

<script>
    import KimsaConfirm from '@/components/common/KimsaConfirm'
    import {mapMutations, mapState} from 'vuex'

    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        components: {KimsaConfirm},
        props:{
            items: {
                type: Array,
                required: true
            },
            allowModifying: {
                type: Boolean,
                default: true
            },
            individualMode: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                loadingActivate: false,
                loadingDelete: false,
                confirmTitle: '',
                confirmContent: '',
                selectedItem: null
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            onDelete(item){
                var vm = this
                vm.selectedItem = item
                vm.$refs.deleteScheduleDialog.show()
            },
            onActivate(item){
                var vm = this

                vm.selectedItem = item
                vm.confirmTitle = `${vm.activeText} Agenda`
                vm.confirmContent = `Seguro(a) de querer ${vm.activeText.toLowerCase()} esta agenda?`
                vm.$refs.activateScheduleDialog.show()
            },
            async onActivateConfirm(){

                var vm = this
                if (vm.loadingActivate) return

                vm.loadingActivate = true
                const response = await ApiUtils.makePatch(`schedules/${vm.selectedItem.id}/active`, null, {
                    active: vm.selectedItem.active ? 0 : 1
                })
                vm.loadingActivate = false

                if (!response.ok) {
                    const json = await response.json()
                    vm.showSnackBar(json.message || `Ha ocurrido un error intentando ${vm.activeText.toLowerCase()} la agenda`)
                    return
                }

                const json = await response.json()
                vm.$emit('activate', json.result.schedule)
                vm.$refs.activateScheduleDialog.hide()

            },
            async onDeleteConfirm(){

                var vm = this
                if (vm.loadingDelete) return

                vm.loadingDelete = true
                const response = await ApiUtils.makeDelete(`schedules/${vm.selectedItem.id}`)
                vm.loadingDelete = false

                if (!response.ok) {
                    const json = await response.json()
                    vm.showSnackBar(json.message || `Ha ocurrido un error intentando eliminar la agenda`)
                    return
                }

                vm.$emit('delete', vm.selectedItem.id)
                vm.selectedItem = null
                vm.showSnackBar('La agenda ha sido eliminada')
                vm.$refs.deleteScheduleDialog.hide()

            },
            onClick(item){
                var vm = this
                const scheduleRoute = vm.individualMode ? 'my_schedules' : 'schedule'
                vm.$router.push({
                    name: `panel.provider.${scheduleRoute}.details`,
                    params: { id: item.id }
                })
                vm.$emit('select', item)
            }
        },
        computed: {
            ...mapState(['currentProvider']),
            activeText(){
                var vm = this
                return vm.selectedItem && vm.selectedItem.active ? 'Desactivar' : 'Activar'
            }
        },
        watch: {
            selectedItem(item){
                var vm = this
            }
        }
    }
</script>